<template>
  <div id="status" class="h100"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "DeviceStatus",
  props: {
    propData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      statusChart: null
    };
  },
  mounted() {
    this.initStatus();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.statusChart.resize);
  },
  methods: {
    initStatus() {
      this.statusChart = echarts.init(document.getElementById("status"));
      this.statusChart.setOption({
        tooltip: {
          trigger: "item",
          padding: 0,
          borderWidth: 0,
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          formatter: params => `<div class="status-tooltip-content">
               <div class="status-tooltip-title">
                 <div class="status-tooltip-tip" style="background: ${params.color}"></div>
                 <span>${params.name}</span>
               </div>
               <div class="status-tooltip-num">
                 <span style="margin-right: 10px;">${params.value}</span>
                 <span>${params.percent}%</span>
               </div>
            </div>`
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["62%", "90%"],
            avoidLabelOverlap: false,
            itemStyle: {
              normal: {
                borderWidth: 3,
                borderColor: "#fff"
              }
            },
            label: {
              show: false,
              position: "center"
            },
            emphasis: {
              label: {
                show: false
              }
            },
            labelLine: {
              show: false
            },
            data: this.propData
          }
        ]
      });
      window.addEventListener("resize", this.statusChart.resize);
    }
  }
};
</script>

<style>
.status-tooltip-content {
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  padding: 8px 18px;
  min-width: 100px;
}
.status-tooltip-title {
  position: relative;
  margin-bottom: 2px;
}
.status-tooltip-tip {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 6px;
  border-radius: 6px;
  left: -10px;
}
</style>
